module.exports = __webpack_public_path__ + "images/article-4-cover.jpg";